<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page :title="title">
      <!-- <template #button v-if="$zutil.role('4')">
               <w-tooltip md top color="white" bg-color="black" >
                  <template #activator="{ on }">
                <w-button dark class="green--bg ml1" :route="$route('pdbf.penilaian.form',0)" v-on="on" ><div style="width: 5px"></div>
                    <w-icon md class="mr1">fal fa-print</w-icon>
                </w-button><div style="padding-right: 45px"></div>
             </template>
                Cetak Borang
             </w-tooltip>
            </template> -->
         <!-- <div class="w-card__content content-hardcode">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px; " v-model="pencarian.no_kes_id" :items="no_kes_id" label="No Kes"/>
              <z-select style="margin:5px; " v-model="pencarian.ternakan_id" :items="ternakan_id" label="ID Ternakan" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;RESET</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div> -->
       <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'Senarai Permohonan Penilaian Daya Biak & Fertiliti'" >
         <w-flex justify-end class="mt2"> 
               <w-tooltip md top color="white" bg-color="black" >
                  <template #activator="{ on }">
                <w-button dark class="green--bg ml1" @click="cetak(id)" v-on="on" ><div style="width: 5px"></div>
                    <w-icon md class="mr1">fal fa-print</w-icon>
                </w-button><div style="padding-right: 45px"></div>
             </template>
                Cetak Borang
             </w-tooltip>
           </w-flex>
           &nbsp;
            <div class="w-table-wrap" style="max-height: 400px;">
            <div class="table-profil-scrol">
              <table class="w-table" color="light" >
                <thead>
                  <tr>
                    <th class="w-table__header  text-center" width="1%">BIL</th>
                    <th class="w-table__header  text-center">NO KES </th>
                    <th class="w-table__header  text-center">ID TERNAKAN / NAMA</th>
                    <th class="w-table__header  text-center">JENIS TERNAK</th>
                    <th class="w-table__header  text-center">TARIKH PEMERIKSAAN</th>
                    <th class="w-table__header  text-center">TARIKH LAPORAN</th>
                    <th class="w-table__header  text-center">BERAT BADAN</th> 
                    <th class="w-table__header  text-center">SKOR BADAN</th> 
                    <th class="w-table__header  text-center">FIZIKAL AM</th> 
                    <th class="w-table__header  text-center">STATUS PEMERIKSAAN</th>  
                    <th class="w-table__header  text-center">ULASAN</th>      
                  </tr>
                </thead>
                <tbody>
                  <template v-if="sejarah.length == 0">
                    <tr class="w-table__row" >
                      <td class="w-table__cell text-left" colspan="9"> Tiada Data.</td>
                    </tr>
                  </template>
                  <template v-for="(data, ind) in sejarah">
                    <tr class="w-table__row" >
                      
                      <td class="w-table__cell text-left" >{{ind+1}}</td>
                      <td class="w-table__cell text-left" >{{data.no_kes}}</td>
                      <td class="w-table__cell text-left" >{{data.ternakan_kode}}</td>
                      <td class="w-table__cell text-left" >{{data.ternakan}}</td>
                      <td class="w-table__cell text-left" >{{data.tarikh_pemeriksa}}</td>
                      <td class="w-table__cell text-left" >{{data.tarikh_laporan}}</td>
                      <td class="w-table__cell text-right" >{{data.berat_badan}}</td>
                      <td class="w-table__cell text-right" >{{data.skor}}</td>
                      <td class="w-table__cell text-left" >{{data.fizikal_am}}</td>
                      <td class="w-table__cell text-left" >{{data.status_pemeriksa}}</td>
                      <td class="w-table__cell text-left" >{{data.ulasan}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
              </div>
            </div>
        </w-card>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id : [Object],
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'pdbf.penilaian',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Perkhidmatan Daya Biak & Fertiliti', route: '/pdbf' },
        { label: 'PDBF Penilaian', route: '/pdbf/penilaian' },
      ],
      title : 'Pdbf Penilaian',
      form : this.d_form,
      
      
      pencarian: {
         no_kes_id: '',
         ternakan_id: '',
      },
      no_kes_id: [],
      ternakan_id:[],
      sejarah: [],
      
      
    }
  },
  methods: {
       

    getData(){

      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'pdbf/sejarah/'+this.id, {}).then(res => {
          this.sejarah = res
          this.load = this.load + 1
        })
      }
      
    },

    cetak(id){
        // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
        window.open( window.route('pdbf.penilaian.cetak', id), '_blank');
    },

    tutup(){
         this.$inertia.visit(window.route('pdbf.penilaian.index'));
       },
  
  },

  watch: {

  },
  mounted() {
   if(this.data.jantina==1)
    {
      this.title = 'Rekod Maklumat Penilaian Fertiliti Jantan'
    }
    else
    {
      this.title = 'Rekod Maklumat Penilaian Fertiliti Betina'
    }
   this.getData()
   // this.getPremis();
   // this.getPenilai();
   // this.getPremisCarian();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
